import { createContext, useContext, useEffect, useMemo, useState } from "react";
import Cookies from 'universal-cookie';

const LangagueContext = createContext();
const cookies = new Cookies()

const getDefaultLanguage = () => {
    const browserLanguage = navigator.language || navigator.languages?.[0] || "fr";
    const lang = browserLanguage.substring(0, 2).toLowerCase();
    return lang === "en" ? "en" : "fr"; 
};

const LanguageProvider = ({ children }) => {
    const [language, setLanguage_] = useState(() => cookies.get("language") || getDefaultLanguage());

    const setLanguage = (newLanguage) => {
        setLanguage_(newLanguage);
    };

    useEffect(() => {
        if (language) {
            cookies.set('language', language);
        } else {
            cookies.remove('language', { path: '/' })
        }
    }, [language]);

    const contextValue = useMemo(
        () => ({
            language,
            setLanguage,
        }),
        [language]
    );

    return (
        <LangagueContext.Provider value={contextValue}>{children}</LangagueContext.Provider>
    );
};

export const useLang = () => {
    return useContext(LangagueContext);
};

export default LanguageProvider;